// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OutfitterAssistantSuggestionsQueryVariables = Types.Exact<{
  input: Types.OutfitterAssistantSuggestionsInput;
}>;


export type OutfitterAssistantSuggestionsQuery = { __typename?: 'Query', outfitterAssistantSuggestions: Array<string> };


export const OutfitterAssistantSuggestionsDocument = gql`
    query outfitterAssistantSuggestions($input: OutfitterAssistantSuggestionsInput!) {
  outfitterAssistantSuggestions(input: $input)
}
    `;

/**
 * __useOutfitterAssistantSuggestionsQuery__
 *
 * To run a query within a React component, call `useOutfitterAssistantSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutfitterAssistantSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutfitterAssistantSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOutfitterAssistantSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<OutfitterAssistantSuggestionsQuery, OutfitterAssistantSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutfitterAssistantSuggestionsQuery, OutfitterAssistantSuggestionsQueryVariables>(OutfitterAssistantSuggestionsDocument, options);
      }
export function useOutfitterAssistantSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutfitterAssistantSuggestionsQuery, OutfitterAssistantSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutfitterAssistantSuggestionsQuery, OutfitterAssistantSuggestionsQueryVariables>(OutfitterAssistantSuggestionsDocument, options);
        }
export type OutfitterAssistantSuggestionsQueryHookResult = ReturnType<typeof useOutfitterAssistantSuggestionsQuery>;
export type OutfitterAssistantSuggestionsLazyQueryHookResult = ReturnType<typeof useOutfitterAssistantSuggestionsLazyQuery>;
export type OutfitterAssistantSuggestionsQueryResult = Apollo.QueryResult<OutfitterAssistantSuggestionsQuery, OutfitterAssistantSuggestionsQueryVariables>;